import React from "react";

export function NotFoundPage() {
  return (
    <div className="page-container">
      <div className="content" style={{ textAlign: "center", paddingTop: "60px" }}>
        <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>404</h1>
        <h2>Page Not Found</h2>
        <p style={{ color: "#7f8c8d", marginTop: "20px" }}>
          The page you're looking for doesn't exist.
        </p>
        <a href="/wallet" style={{ marginTop: "30px", display: "inline-block" }}>
          ← Back to Wallet
        </a>
      </div>
    </div>
  );
}
